// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.help-icon[data-v-6b018373] {\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  border-radius: 2px;\n  background-color: #5a5e66;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 18px;\n  text-align: center;\n  vertical-align: -0.15em;\n}\n", ""]);
// Exports
module.exports = exports;
